<template>
    <div>
        <div>
            正在筹备中...
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_jd_help",
        data() {
            return {

            }
        },
        created() {
            // this.initWxUserInfo();
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>